<template>
  <div class="area" :class="{ 'area-full': fullHeight }">
    <div>
      <p class="headline ma-0 lh-0" :class="`${color}--text`">{{ title }}</p>
      <p class="subtitle-1 ma-0 lh-0">{{ subtitle }}</p>
    </div>

    <draggable class="inner" :list="items" group="notes">
      <v-chip
        class="ma-1"
        :class="color"
        v-for="(tag, index) in items"
        :key="index"
      >
        <span class="pr-2 cursor--order">
          {{ tag }}
        </span>
        <v-icon small @click="removeItem(index)">mdi-close</v-icon>
      </v-chip>
    </draggable>

    <div>
      <v-form @submit.prevent ref="form" v-model="valid">
        <v-row class="d-flex align-end">
          <v-col cols="8">
            <v-text-field
              class="ma-0"
              label="Add an item"
              v-model.trim="item"
              :rules="titleRules"
              type="text"
              :id="`${title}-title`"
              required
              :hide-details="true"
            ></v-text-field>
          </v-col>
          <v-col cols="4" class="d-flex flex-row">
            <v-btn
              :class="color"
              class="grey darken-2 align-self-end"
              @click="addNote"
              >Add</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import draggable from "vuedraggable";
export default {
  name: "PropositionArea",
  props: {
    title: String,
    subtitle: String,
    color: String,
    value: Array,
    fullHeight: Boolean,
  },
  components: {
    draggable,
  },
  data() {
    return {
      items: this.value,
      valid: true,
      item: "",
      titleRules: [(v) => !!v || "Title is required"],
    };
  },
  watch: {
    items: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
    value(val) {
      this.items = val;
    },
  },
  methods: {
    addNote() {
      this.validate();
      if (this.valid) {
        this.items.push(this.item);
        this.item = "";
        this.resetValidation();
        this.$emit("update");
      }
    },
    removeItem(index) {
      this.items.splice(index, 1);
      this.$emit("update");
    },
    validate() {
      this.$refs.form.validate();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
};
</script>
